"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
// /feecategories/{pk}/fees
var FeeCategoryResource = /** @class */ (function (_super) {
    tslib_1.__extends(FeeCategoryResource, _super);
    function FeeCategoryResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeeCategoryResource.endpoint = '/feecategories';
    FeeCategoryResource.MODEL_NAME = 'feecategory';
    FeeCategoryResource.related = {
        parent: FeeCategoryResource
    };
    return FeeCategoryResource;
}(base_1.default));
exports.default = FeeCategoryResource;
//# sourceMappingURL=feecategory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/feecategory.js
// module id = /j6p
// module chunks = 0